var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-4"},[_c('div',{staticClass:"skeleton-title"}),_c('div',{staticClass:"skeleton-line"}),_c('div',{staticClass:"skeleton-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }